import { Show } from '@/components/show'
import { RenderResourceProps } from '../types'
import { Practitioner } from './types'
import { PractitionerName, PractitionerUsualName } from './PractitionerName'
import { PractitionerQualification } from './PractitionerQualification'
import { PractitionerRedaction } from './PractitionerRedaction'
import { PractitionerDeceased } from './PractitionerDeceased'

export function RenderPractitioner({
  resource,
  inputValue
}: RenderResourceProps<Practitioner>) {
  const officialId = resource.identifier.filter(
    id =>
      id.system === 'https://standards.digital.health.nz/ns/hpi-person-id' &&
      id.use === 'official'
  )[0]?.value

  const mismatch = inputValue && inputValue !== officialId

  return (
    <div className='w-full grow py-1'>
      <div className='flex flex-wrap items-center gap-2'>
        <PractitionerName name={resource.name} />
        <PractitionerDeceased practitioner={resource} />
      </div>

      <PractitionerUsualName name={resource.name} />
      <p className='text-muted-foreground text-xs'>
        <span>ID: {officialId ?? '—'}</span>
        <Show when={mismatch}>
          <span className='text-destructive'>
            {' '}
            (requested CPN {inputValue} is no longer live)
          </span>
        </Show>
      </p>
      <PractitionerQualification qualification={resource.qualification} />
      <PractitionerRedaction practitioner={resource} />
    </div>
  )
}
